__turbopack_context__.v({
  "products": "products-module-scss-module__u_U72W__products",
  "productsHeader": "products-module-scss-module__u_U72W__productsHeader",
  "productsSupertitle": "products-module-scss-module__u_U72W__productsSupertitle",
  "productsTitle": "products-module-scss-module__u_U72W__productsTitle",
});
